import styled from 'styled-components';

const GalleryItemCheckbox = styled.div`
  z-index: 5;
  width: 100%;
`;

const LayerButtonsRow = styled.div`
  z-index: 5;
  bottom: 0;
  margin-left: -4px;
`;

export default { GalleryItemCheckbox, LayerButtonsRow };
